import { render, staticRenderFns } from "./QueueEditor.vue?vue&type=template&id=b5a15018&"
import script from "./QueueEditor.vue?vue&type=script&lang=js&"
export * from "./QueueEditor.vue?vue&type=script&lang=js&"
import style0 from "./QueueEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverflowBtn } from 'vuetify/lib/components/VOverflowBtn';
installComponents(component, {VBtn,VCardTitle,VDataTable,VIcon,VOverflowBtn})
